/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'fabric.editor.chromeCollapsedPlaceholder': '文字を入力…',
  'fabric.editor.editorAssistiveLabel': 'メイン コンテンツ領域。入力を開始してテキストを入力します。',
  'fabric.editor.headingLink.toolbarHelpTitle': 'ヘルプ ダイアログを開く',
};
